export default __webpack_public_path__ + "static/media/98_desktop.18cfc515.jpg";